/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForSaasNewRelic extends models.ServiceAccountNativeDetailsBaseForSaasOtherServices {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForSaasNewRelic");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForSaasNewRelic.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForSaasNewRelic>): ServiceAccountNativeDetailsForSaasNewRelic {
        let obj = Object.assign(new ServiceAccountNativeDetailsForSaasNewRelic(), model);
        ServiceAccountNativeDetailsForSaasNewRelic.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForSaasNewRelic>): ServiceAccountNativeDetailsForSaasNewRelic {
        if (!model) return null;
        return ServiceAccountNativeDetailsForSaasNewRelic.newInstance(<ServiceAccountNativeDetailsForSaasNewRelic> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForSaasNewRelic) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForSaasNewRelic.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForSaasNewRelic): boolean {
        if (models.ServiceAccountNativeDetailsBaseForSaasOtherServices.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForSaasNewRelic.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
